import asyncFactory from "@/client/extensions/modules/asyncComponentFactory.js";

export default [
  {
    path: "/:pathMatch(.*)*",
    component: asyncFactory("applications/saffronfiles/views/PageNotFound.vue"),
    meta: {
      layout: "none",
      layoutParams: {
        wrapMainContent: true,
        showTopBanners: true,
      },
    },
  },
];
